module.exports = __webpack_public_path__ + "static/media/close-line.5dcf3140.svg";